import { Component } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'app-under-construction',
  imports: [TranslatePipe, TranslatePipe],
  templateUrl: './under-construction.component.html',
  styleUrl: './under-construction.component.scss'
})
export class UnderConstructionComponent {}
